module.exports = __webpack_public_path__ + "static/media/overlook.db9a8878.svg";